import { Locale } from '@fluidx/utilities';
import { TranslatedStringTableFetcher } from '@fluidx/localize-js';
import { HostUxStrings, getHostUxStrings } from '../stringTypes/HostUxStrings';

const stringTableFetcher: TranslatedStringTableFetcher = (locale) => {
  return import(/* webpackChunkName: "hostUxStrings" */ `../translations/${locale}/HostUxStrings.json`);
};

export function getStringTable(locale: Locale): Promise<HostUxStrings> {
  return getHostUxStrings(stringTableFetcher, locale);
}
